require('./../../Modules/jquery/hasAttr');
;(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function ($) {
    $.fn.rbmForm = function (formName, options) {
        if (formName !== undefined && formName !== '') {
            var formSettings = {
                type: "form",
                form: {
                    notification: {
                        type: "jGrowl",
                        errorTheme: "ui-state-error",
                        errorTTL: 10000,
                        successTheme: "ui-state-highlight",
                        successTTL: 10000
                    }
                },
                button: {
                    container: ".modal-container",
                    yaID: undefined,
                    yaKey: undefined,
                    productID: undefined
                }
            };
            if (options !== undefined && typeof (options) == "object") {
                formSettings = $.extend(true, formSettings, options);
            }

            return this.each(function (i, item) {
                // Добавление к DOM-елементу собственных свойств
                if (this.rbmForm === undefined) {
                    this.rbmForm = $.extend(true, {}, formSettings);
                }
                switch (formSettings.type) {
                    case "form":
                        if (item.tagName === "FORM" || $(item).hasClass('form')) {
                            let $form = $(this),
                                $button_submit = $form.find('button.submit').length ? $form.find('button.submit') : $form.find('button, input[type="submit"]').filter(':last'),
                                $fields = $form.find('*[name]');

                            $(this).on('submit', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            });
                            // add needed elements to button
                            if (!$form.find('.rbm_js_btn_send_msg').length) {
                                $button_submit.addClass('rbm_js_btn_send_msg');
                            }

                            if (!$button_submit.hasAttr('data-msg_name')) {
                                $button_submit.data("msg_name", formName);
                            }

                            // needed elements to fields
                            $fields.each(function () {
                                $(this)
                                    .addClass('rbm_js_input_form');
                                //.parents(formSettings.form.inputWrapSelector).addClass('rbm_js_input_wrap')
                                //.find(formSettings.form.inputErrorSelector).addClass('rbm_js_error_description');
                            });
                            $form
                                .addClass('rbm_js_form_' + formName)
                                .attr("novalidate", "");
                        } else {
                            $.error("RBMForm: FORM expected, got " + item.tagName);

                        }
                        break;
                    case "button":
                        this.rbmForm.button.productID = $(this).data('product_id');
                        $(this)
                            .addClass('rbm_js_btn_open_form')
                            .data('form_name', formName);
                        if ($('.rbm_js_form_wrap_' + formName).length === 0)
                            $('body').find(formSettings.button.container).append("<div class='rbm_js_form_wrap_" + formName + "' style='display:none'></div>");
                        break;
                    default:
                        $.error("RBMForm: Unknown type " + formSettings.type);
                }
            });
        } else {
            $.error("RBMForm: Needed a form name.");
        }
    }
}));